'use client';

import React from 'react';

export const GateStyleContext = React.createContext({
});

export default function GateStyleProvider({ children, ...data }) {
	return (
		<GateStyleContext.Provider value={data}>
			{children}
		</GateStyleContext.Provider>
	);
}
